import { render, staticRenderFns } from "./CustomTechnicianChips.vue?vue&type=template&id=c5b2172c"
import script from "./CustomTechnicianChips.vue?vue&type=script&lang=js"
export * from "./CustomTechnicianChips.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports